<template>
  <section style="padding: 1.5em">
    <div class="row">
      <div class="col-md-1">
        <label>Show Records</label>
        <select class="form-control h-43" v-model="showRecords">
          <option value="10">10</option>
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Search By Domain / Email</label>
        <input v-model="searchQuery" type="text" class="form-control h-43" placeholder="example.com" />
      </div>
    </div>
    <div v-if="fetchingData" class="customer-list-info"  >
      <div class="loader" />
    </div>
    <div v-else class="row">
      <div class="col-md-12">
        <div class="accordion mt-3" id="accordionExample">
          <div v-for="(task, index) in filteredTasks" :key="'migrations_' + index" class="card card-body domain-card">
            <div class="media d-flex align-items-center">
              <button class="btn btn-sm btn-primary my-0 mr-4" data-toggle="collapse" :data-target="'#collapse_' + index + type" :aria-controls="'collapseOne_' + index" @click="collapseIndex === index ? collapseIndex = -1 : collapseIndex = index"><i class="fa" :class="collapseIndex === index ? 'fa-minus' : 'fa-plus'"></i></button>
              <div class="media-body">
                <div class="domain-head  d-flex align-items-center">
                  <h5 class="mt-1 h5-m0">
                    <a :href="'https://' + task.domain" target="_blank" class="mr-2">{{task.domain}}</a><i class="fa fa-copy text-primary ml-5 mr-5 cursor-pointer" @click="doCopy(task.domain)" />
                    <small><span class="fs-10 badge mr-2" :class="{'badge-danger' : task.status !== 'finished', 'badge-success' : task.status === 'finished'}">
                                         {{(task.status !== 'finished' && task.customStatus) ? task.customStatus : task.status}}
                                         <a href="javascript:void(0)" v-if="task.status !== 'finished'" @click="changeCustomStatus(task)" class="fa fa-pencil text-white"></a>
                                       </span></small>
                    <small><a @click="doCopy(task.email)" href="javascript:void(0)" class="fs-10 badge badge-info mr-2"><i class="fa fa-copy"></i> {{ task.email }}</a></small>
                    <small v-if="task.requestedPlan"><a @click="doCopy(task.requestedPlan)" href="javascript:void(0)" :style="task.requestedPlan === 'Mediavine Security' ? 'background-color: #fec6ff; border-color: #fec6ff' : ''" class="fs-10 badge badge-warning" style="color: #7e3410a8 !important;"><i class="fa fa-copy"></i> {{ task.requestedPlan }}</a></small>
                  </h5>
                  <section>
                    <ul class="list-inline ul-m0">
                      <li v-if="!task.handledBy" @click="checkInTask(task)" class="list-inline-item"><button class="btn btn-sm btn-primary">CheckIn</button></li>
                      <li v-else class="list-inline-item" >
                         <span class="badge badge-info">
                             Handled By {{task.handledBy}}
                             <a href="javascript:void(0)" v-if="task.status === 'pending'" @click="checkOutTask(task)" class="fa fa-times text-white"></a>
                         </span>
                      </li>
                      <li @click="goToNuxt(task.uid)" class="list-inline-item" title="Login as user"><button class="btn btn-sm btn-primary"><i class="fa fa-user"></i></button></li>
                      <li v-if="task.ticketId" @click="viewTicket(task)" class="list-inline-item" title="View Ticket"><button class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button></li>
                      <li @click="remove(task)" class="list-inline-item" title="Remove"><button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button></li>
<!--                      <li @click="openNotesModal(task)" class="list-inline-item"><button class="btn btn-sm btn-default"> <i  v-if="task.status !== 'finished'" class="fa" :class="(task.notes && task.notes.length > 0) ? 'fa-pencil' : 'fa-plus'"></i> Notes</button></li>-->
                    </ul>
                  </section>
                </div>
              </div>
            </div>
            <div :id="'collapse_' + index + type" class="collapse" data-parent="#accordionExample">
              <div class="card-body">
                <form @submit.prevent="finishTask(task, index)">
                  <div class="row">
                    <div class="col-md-12">
                      <section v-if="task.notes && task.notes.length > 0" class="notes-section">
                        <h5 class=""><b>Added Notes</b></h5>
                        <div  class="row">
                          <div :class="(task.status !== 'finished' && task.status !== 'pending') ? 'col-md-4' : 'col-md-6'">
                            <dl>
                              <dt>Note</dt>
                            </dl>
                          </div>
                          <div class="text-center col-md-2">
                            <dl>
                              <dt>Added By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center">
                            <dl>
                              <dt>Completed By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center" v-if="task.status !== 'pending'">
                            <dl>
                              <dt>Reviewed By</dt>
                            </dl>
                          </div>
                          <div class="col-md-2" v-if="task.status !== 'finished'">
                            <dl>
                              <dt class="pull-right">Action</dt>
                            </dl>
                          </div>
                        </div>
                        <div class="row" v-for="(note, note_index) of task.notes" :key="'notes_'+note_index">
                          <div :class="(task.status !== 'finished' && task.status !== 'pending') ? 'col-md-4' : 'col-md-6'" >
                            <dl>
                              <dd>
                                <span v-html="getText(note.text)"></span>
                              </dd>
                              <dd><a v-if="note.imageUrl" :href="note.imageUrl" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i>View Attachment</a></dd>
                            </dl>
                          </div>
                          <div class="text-center col-md-2">
                            <dl>
                              <dd>{{ note.addedBy }}</dd>
                            </dl>
                          </div>
                          <div class="col-md-2 text-center">
                            <div v-if="task.status === 'pending' && !note.completedBy" class="custom-control custom-checkbox p mr-sm-2">
                              <input type="checkbox" required  :disabled="task.status !== 'pending'" @change="acknowledgeNote(task, note, 'complete')" class="custom-control-input" :id="'notes' + index + 'complete-ackNotes'"/>
                              <label class="custom-control-label pt-1" :for="'notes' + index + 'complete-ackNotes'"></label>
                            </div>
                            <div v-else>
                              <span class="badge badge-primary text-center">{{(note.completedBy) ? note.completedBy : 'Acknowledged'}}</span>
                            </div>
                          </div>
                          <div class="col-md-2 text-center" v-if="task.status !== 'pending'">
                            <div v-if="task.status === 'review' && !note.reviewedBy" class="custom-control custom-checkbox p mr-sm-2">
                              <input type="checkbox" required :disabled="task.status !== 'review'" @change="acknowledgeNote(task, note, 'review')" class="custom-control-input" :id="'notes' + index + 'review-ackNotes'"/>
                              <label class="custom-control-label pt-1" :for="'notes' + index + 'review-ackNotes'"></label>
                            </div>
                            <div v-else>
                              <span class="badge badge-primary text-center">{{(note.reviewedBy) ? note.reviewedBy : 'Acknowledged'}}</span>
                            </div>
                          </div>
                          <div class="col-md-2" v-if="task.status !== 'finished'">
                            <button type="button" class="btn btn-sm btn-danger my-1 pull-right" @click="deleteMigrationNote(task.notes, task.docId, note_index)"><i class="fa fa-trash"></i></button>
                          </div>
                          <div class="col-md-12" v-if="note_index < task.notes.length-1">
                            <hr>
                          </div>
                        </div>
                      </section>
                      <hr v-if="task.notes && task.notes.length > 0" class="h-3">
                      <h5 class=""><b>Server IP: </b> {{ task.ip }}
                        <small><a href="javascript:void(0)" class="fs-10 badge badge-info"> {{ formattedDate(task.created) }}</a></small>
                      </h5>
                      <span v-if="task.movedAt">Moved to {{type}}: <small v-if="task.movedAt"><a href="javascript:void(0)" class="fs-10 badge badge-primary">{{formattedDate(task.movedAt) }}</a></small></span>

                      <hr class="h-3">
                      <h5 v-if="task.requestedPlan !== 'Mediavine Security'" class=""><b>Google Search Console</b></h5>
                      <div v-if="task.requestedPlan !== 'Mediavine Security'" class="row">
                        <!--                                           <div class="col-md-3">-->
                        <!--                                               <dl>-->
                        <!--                                                   <dt>Domain Name</dt>-->
                        <!--                                                   <dd>{{ migration.siteDetails.domainName }} <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.domainName)"><i class="fa fa-copy"></i></a></dd>-->
                        <!--                                               </dl>-->
                        <!--                                           </div>-->
                        <div class="col-md-4">
                          <dl>
                            <dt>Google Search Console</dt>
                            <dd>{{ task.gscInvite ? 'Access Given' : 'N/A' }}</dd>
                          </dl>
                        </div>
<!--                        <div class="col-md-3">-->
<!--                          <dl>-->
<!--                            <dt>Hosting Panel Login</dt>-->
<!--                            <dd><a class="mr-1" target="_blank" :href="getLink(migration.siteDetails.hostingPanelLogin)">{{migration.siteDetails.hostingPanelLogin}}</a> <a href="javascript:void(0)" @click="doCopy(migration.siteDetails.hostingPanelLogin)"><i class="fa fa-copy"></i></a></dd>-->
<!--                          </dl>-->
<!--                        </div>-->
                      </div>
                      <h5 class=""><b>Environment</b></h5>
                      <div class="row">
                        <div class="col-md-4">
                          <dl>
                            <dt>Selected Environment</dt>
                            <dd class="text-transform">{{task.environment}}</dd>
                          </dl>
                        </div>
                        <div class="col-md-4" v-if="task.environment === 'staging'">
                          <dl>
                            <dt>Overwrite Staging</dt>
                            <dd class="text-transform">{{task.overwriteStaging}}</dd>
                          </dl>
                        </div>
                      </div>
                      <hr class="h-3">
                      <div class="row">
                        <div class="col-md-4 pr-0 has-text-centered">
                          <h5 class=""><b>Additional Notes or Special Requests</b></h5>
                        </div>
                        <div v-if="task.comments && task.comments.length" class="col-md-8 text-left">
                          <dd>{{ task.comments }}</dd>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="h-3" />
                  <div v-if="type !== 'abandoned'" class="row">
                    <div class="col-md-12">
                      <h5 class="" v-if="task.checklist && task.checklist.length > 0" :class="{'pull-left': !task.handledBy}"><b>{{task.requestedPlan || 'Cloudflare Enterprise' }} Checklist</b></h5>

                      <template v-if="task.handledBy">
                        <section>
                          <table class="table table-hover">
                            <tbody>
                              <tr v-for="(tt, task_index) of filteredTaskList(task)" :key="'tasks_' + task_index">
                              <td class="task-width" v-if="!tt.heading" :style="(tt.pl) ? 'padding-left: 50px  !important;' : ''">
                                <template>
                                  <span v-html="(tt.text).replace(/\n/g, `<br/>`)"></span>
                                </template>
                              </td>
                              <td v-else colspan="4"><b v-html="(tt.text).replace(/\n/g, `<br/>`)"></b></td>
                              <td class="text-center" v-if="!tt.heading">
                                <section v-if="loader === 'complete' + index + task_index">
                                  <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                </section>
                                <section v-else>
                                  <div v-if="!tt.pendingIsChecked" class="custom-control custom-checkbox p mr-sm-2">
                                    <input type="checkbox" :disabled="task.status === 'finished'" @change="completeTask(index, task_index)" class="custom-control-input" :id="type + 'm' + index +'q' + task_index + 'a'"/>
                                    <label class="custom-control-label pt-1" :for="type + 'm' + index +'q' + task_index + 'a'"></label>
                                  </div>
                                  <div v-else>
                                    <span class="badge badge-primary">{{ tt.pendingCheckedBy }}</span>
                                  </div>
                                </section>
                              </td>
                              <td class="text-center" v-if="!tt.heading && task.status !== 'pending'">
                                <section v-if="loader === 'review' + index + task_index">
                                  <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                </section>
                                <section v-else>
                                  <div v-if="!tt.reviewIsChecked" class="custom-control custom-checkbox p mr-sm-2">
                                    <input type="checkbox" :disabled="task.status === 'finished'" @change="reviewTask(index, task_index)" class="custom-control-input" :id="type + 'm' + index +'q' + task_index + 'b'" />
                                    <label class="custom-control-label pt-1" :for="type + 'm' + index +'q' + task_index + 'b'"></label>
                                  </div>
                                  <div v-else>
                                    <span class="badge badge-primary">{{ tt.reviewCheckedBy }}</span>
                                  </div>
                                </section>
                              </td>
                              <td class="text-center" v-if="!tt.heading">
                                <button class="btn btn-sm" :class="(tt.comments && tt.comments.length > 0)? 'btn-danger' : 'btn-link'" @click.prevent="openCommentModal(index, tt)">Comments</button>
                              </td>
                            </tr>
                            </tbody>
                          </table>

                          <div v-if="task.requestedPlan !== 'Mediavine Security'" class="row mt-2">
                            <div class="col-md-4">
                              <label><b>Attach Perfmatters JSON File:</b></label>
                              <input type="file" :disabled="addingFile" class="form-control" id="customFile" ref="file" @change="changeFile($event, task)" accept=".json">
                            </div>
                            <div class="col-md-1"  v-if="addingFile">
                              <div class="loader" style="width: 20px;height: 20px"></div>
                            </div>
                            <div class="col-md-3" v-if="task.jsonUrl" style="align-content: end">
                              <button class="btn btn-sm btn-primary">
                                <i class="fa fa-download mr-4"></i><a class="mt-5 text-white" :href="task.jsonUrl" target="_blank">Download Json File</a>
                              </button>
                            </div>
                          </div>

                          <div v-if="task.requestedPlan !== 'Mediavine Security'" class="row mt-2">
                            <div class="col-md-4" style="align-content: end">
                              <button class="btn btn-sm btn-primary" @click.prevent="openIDsModal('js', task)">Collect JS IDs</button>
                              <button class="btn btn-sm btn-primary" @click.prevent="openIDsModal('css', task)">Collect CSS IDs</button>
                            </div>
                          </div>

                        </section>
                        <template v-if="task.status !== 'finished'">
                          <div class="row">
                            <div class="col-md-11">
                              <button type="submit" class="btn btn-primary pull-left btn-block">Proceed</button>
                            </div>
                            <div class="col-md-1">
                              <ul class="list-inline ul-m0">
                                <li v-if="loading" class="list-inline-item text-center cf-status-icons text-danger">
                                  <div class="loader" style="width: 20px;height: 20px; margin: 0 auto !important;"></div>
                                </li>
                                <li v-if="type === 'pending' && !loading" @click="toggleAbandoned(task, 'abandoned')" class="list-inline-item text-center cf-status-icons text-danger">
                                  <i class="btn btn-link default fa fa-trash" title="Move to Abandoned"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <br><br>
                        <div class="row">
                          <div class="col-md-12"><b class="text-danger">You must have to check-in to this CF task before proceeding <!-- to check list --> </b></div> </div>
                      </template>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <ul class="list-inline ul-m0">
                          <li v-if="loading" class="list-inline-item text-center cf-status-icons text-danger">
                            <div class="loader" style="width: 40px;height: 40px; margin: 0 auto !important;"></div>
                          </li>
                          <li v-if="!loading" @click="toggleAbandoned(task, 'pending')" class="list-inline-item text-center cf-status-icons text-success">
                            <button type="button" class="btn btn-success" @click.prevent="toggleAbandoned(task, 'pending')" >Move to Pending</button>
                          </li>
                          <li v-if="!loading" class="list-inline-item text-center cf-status-icons text-danger">
                            <button type="button" class="btn btn-danger" @click.prevent="deletePermanently(task)" >Delete Permanently</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ pageCount }}
                </span>
        <section class="dataTables_paginate paging_full_numbers">
          <paginate
              :pageCount="pageCount"
              :clickHandler="goToPage"
              :prevText="'Prev'"
              :nextText="'Next'"
              page-class="page-item"
              prev-class="page-item"
              prev-link-class="page-link"
              next-class="page-item"
              next-link-class="page-link"
              page-link-class="page-link"
              containerClass="pagination">
          </paginate>
        </section>
      </div>
    </div>
    <checklist-comments-modal ref="comment" />
  </section>
</template>

<script>
import dateMixin from "@/mixins/dateMixin";
import copyButtonMixin from "@/mixins/copyButtonMixin";
import loginAsMixin from "@/mixins/loginAsMixin";
import {db, storage} from "@/firebase/init";
import swal from "sweetalert2";
import Paginate from 'vuejs-paginate'

export default {
  name: "CFTasks",
  mixins: [dateMixin, copyButtonMixin, loginAsMixin],
  components: {
    Paginate,
    checklistCommentsModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/checklistCommentsModal.vue"
            ),
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      toast: null,
      showRecords: 10,
      pageNumber: 0,
      searchQuery: '',
      searchBy: 'domain',
      loader: null,
      collapseIndex: -1,
      previousTasks: 0,
      updatingCF: false,
      loading: false,
      fetchingData: false,
      showAllSteps: false,
      addingFile: false,
      notifying: null,
      message: '',
      tasks: [],
      listener: null,
      fileContent: null
    }
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    user() {
      return this.$store.getters.user;
    },
    searchedTasks () {
      return this.tasks.filter(el => {
        return el.domain.toLowerCase().includes(this.searchQuery.toLowerCase()) || el.email.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },
    filteredTasks () {
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return this.searchedTasks.slice(start, end);
    },
    pageCount () {
      let l = parseInt(this.searchedTasks.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
    totalTasks () {
      return this.tasks.length
    },
  },
  watch: {
    totalTasks (value) {
      if (this.previousTasks < value) {
        if (this.collapseIndex >= 0) {
          let self = this;
          setTimeout(function () {
            $('#collapse_' + (self.collapseIndex + 1) + self.type).collapse('toggle');
          }, 300)
        }
      }
      this.previousTasks = value;
    },
    searchQuery (value) {
      this.pageNumber = 0
    },
    searchBy (value) {
      this.pageNumber = 0
      }
    },
  mounted () {
    this.getTasks();
    setTimeout(()=>{
      this.fetchingData = false;
    }, 600)
  },
  beforeDestroy() {
    if(this.listener) {
      this.listener()
    }
  },
  methods: {
    async changeFile(event, task) {
      const file = event.target.files[0]
      if (file) {
        this.addingFile = true
        try {
          const reader = new FileReader();
          reader.onload = async (e) => {
            this.fileContent = e.target.result; // Store the content of the file
            const parsedData = JSON.parse(this.fileContent);
            const jssIds = parsedData.perfmatters_options.assets.delay_js_exclusions || [];
            const cssIds = parsedData.perfmatters_options.assets.rucss_excluded_stylesheets || [];
            const storageRef = storage.ref();
            const timestamp = new Date().getTime().toString();
            const fileRef = storageRef.child('cf-checklist-json/' + file.name + timestamp);
            const uploadTask = await fileRef.put(file)
            const downloadURL = await uploadTask.ref.getDownloadURL()
            task.jsonUrl = downloadURL
            await db.collection('CFEnterpriseRequests').doc(task.docId).update({
              jsonUrl: downloadURL,
              jssIds: jssIds,
              cssIds: cssIds,
              modified: new Date().toISOString()
            })
          };
          // Read the file as text
          reader.readAsText(file);
        } catch (e) {
          console.log('error in adding ffile', e)
        }
        this.addingFile = false
        event.target.value = ''
      }
    },
    async remove(task) {
      try {
        swal({
          title: "Are you sure?",
          text: `Are you sure you want to delete ${task.requestedPlan} for ${task.domain}?`,
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async (result) => {
          if (result.value) {
            console.log('hello');
            await db.collection('CFEnterpriseRequests').doc(task.docId).delete();
            swal('Success', `Successfully deleted ${task.requestedPlan} for ${task.domain}.`, 'success')
          }
        })
      } catch (e) {
        console.log('error in adding ffile', e)
        swal('Success', `Something went wrong while deleting ${task.requestedPlan.replace('Plan', '')} Plan.`, 'error')
      }
    },
    async getTasks() {
      if (this.listener) {
        this.listener()
      }
      try {
        this.fetchingData = true;
        this.tasks = []
        this.listener = await db.collection('CFEnterpriseRequests').where('status', '==', this.type).orderBy("created", "desc").onSnapshot(querySnapshot => {
          this.tasks = querySnapshot.docs.map((doc) => ({
            docId: doc.id,
            ...doc.data(),
          }));
        })
        // this.listener = await db.collection('CFEnterpriseRequests').where('status', '==', this.type).onSnapshot(querySnapshot => {
        //   querySnapshot.docChanges().forEach(changeDoc => {
        //     this.tasks.push({
        //       docId: changeDoc.doc.id,
        //       ...changeDoc.doc.data(),
        //     })
        //     // if (changeDoc.type === 'added'){
        //     //   this.tasks.push({docId: changeDoc.doc.id, ...changeDoc.doc.data()})
        //     // }
        //     // if(changeDoc.type === 'modified') {
        //     //   const payload = changeDoc.doc.data()
        //     //   console.log('payload', this.tasks.length, this.tasks, changeDoc.doc.id)
        //     //   this.tasks = this.tasks.filter(el => el.docId !== changeDoc.doc.id)
        //     //   this.tasks.push({docId: changeDoc.doc.id, ...changeDoc.doc.data()})
        //       // taskToUpdate = {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
        //       // taskToUpdate.handledBy = payload.handledBy;
        //       // taskToUpdate.ticketId = payload.ticketId || '';
        //       // taskToUpdate.notes = payload.notes;
        //       // taskToUpdate.jsonUrl = payload.jsonUrl;
        //       // taskToUpdate.cssIds = payload.cssIds;
        //       // taskToUpdate.jssIds = payload.jssIds;
        //     // }
        //     // if(changeDoc.type === 'removed') {
        //     //   this.tasks = this.tasks.filter(el => el.docId !== changeDoc.doc.id)
        //     // }
        //   });
        // });
        console.log('70', this.tasks)
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      } catch (e) {
        console.log('74', e.toString())
      }
    },
    getText(data) {
      return data.replace(/<script/g, '').replace(/<script\/>/g, '').replace(/\n/g, `<br/>`)
          .replace(/<img/g, '').replace(/<a/g, '').replace(/<a\/>/g, '').replace(/<link\/>/g, '');
    },
    viewTicket(data) {
      window.open(`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${data.ticketId}`, '_blank');
    },
    getLink(link) {
      if (link && (link.includes('http://') || link.includes('https://'))) {
        return link;
      } else {
        const newLink = 'https://' + link;
        return newLink
      }
    },
    async toggleAbandoned(task, status) {
      const result = await swal({
        title: "Are you sure?",
        text: `Please confirm that you would like to move this CF task to ${(status === 'pending') ? 'Pending' : 'Abandoned'}.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      });
      if (result.value) {
        this.loading = true;
        try {
          await db.collection('CFEnterpriseRequests').doc(task.docId).update({
            status,
            modified: new Date().toISOString()
          });
          try {
            const keyword = (status === 'pending') ? 'Pending' : 'Abandoned';
            const from = (status === 'pending') ? 'Abandoned' : 'Pending';
            const msg = `${task.domain} has been migrated from ${from} to ${keyword} by ${this.user.firstName} ${this.user.lastName}.`
            await this.$http.post('utilities/send-slack-notification', {
              grant_type: 'token',
              msg,
              showButton: false,
            });
            await this.addLog({
              uid: this.task.uid,
              primaryPlan: this.formatPrimaryDomainName(task.domain),
              message: `User has moved CF Enterprise task for ${this.domain} from ${from} to ${keyword}.`,
              level: "info"
            })
            try {
              await this.removeAdminActiveTask({taskId: task.docId});
            } catch (e) {
              console.log(e.toString())
            }
          } catch (e) {
            console.log(e.toString());
            this.addLog({
              message: e.toString(),
              level: "danger"
            })
          }
        } catch (e) {
          swal({
            title: "Error",
            text: `Error in moving CF Task under ${(status === 'pending') ? 'Pending' : 'Abandoned'}!`,
            type: "error",
          });
        }
        this.addLog({
          message: `Error in moving CF Task under ${(status === 'pending') ? 'Pending' : 'Abandoned'}`,
          level: "danger"
        })
        this.loading = false;
      }
    },
    formatPrimaryDomainName(value) {
      const match = value.match(/(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9]+)+)/i);

      // If there's a match, return the domain group
      if (match && match.length > 1) {
        return match[1];
      } else {
        return 'Account Based Operation'; // Return null if no match found
      }
    },
    async deletePermanently(task) {
      const result = await swal({
        title: "Are you sure?",
        text: `Please confirm that you would like to remove this CF task permanently.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      });
      if (result.value) {
        this.loading = true;
        try {
          await db.collection('CFEnterpriseRequests').doc(task.docId).delete();
          swal({
            title: "Deleted!",
            text: 'CF Enterprise task has been deleted permanently!',
            type: "success",
          });
          try {
            const msg = `CF Enterprise task for ${task.domain} has been deleted permanently by *${this.user.firstName}* *${this.user.lastName}*.`
            await this.$http.post('utilities/send-slack-notification', {
              grant_type: 'token',
              msg,
              showButton: false,
            });

            await this.addLog({
              uid: this.task.uid,
              primaryPlan: this.formatPrimaryDomainName(this.task.domain),
              message: `CF Enterprise task for ${this.domain} has been deleted permanently.`,
              level: "info"
            })
          } catch (e) {
            console.log(e.toString());
            this.addLog({
              message: e.toString(),
              level: "danger"
            })
          }
        } catch (e) {
          swal({
            title: "Error",
            text: `Error in deleting this CF enterprise request!`,
            type: "error",
          });
          this.addLog({
            message: "Error in deleting this CF enterprise request",
            level: "danger"
          })
        }
        this.loading = false;
      }
    },
    changeCustomStatus(task) {
      this.$parent.$refs.customStatus.load(task)
    },
    async acknowledgeNote(task, note, type) {
      if (type === 'review') {
        note.reviewedBy = this.user.firstName + ' ' + this.user.lastName
      } else {
        note.completedBy = this.user.firstName + ' ' + this.user.lastName
      }
      await db.collection('CFEnterpriseRequests').doc(task.docId).update({
        notes: task.notes,
        modified: new Date().toISOString()
      })
    },
    async deleteMigrationNote(notes, docId, index) {
      notes.splice(index, 1)
      await db.collection('CFEnterpriseRequests').doc(docId).update({
        notes,
        modified: new Date().toISOString()
      })
    },
    goToPage(pageNum) {
      this.pageNumber = pageNum - 1;
    },
    async checkInTask(task) {
      await db.collection('CFEnterpriseRequests').doc(task.docId).update({
        handledBy: this.user.firstName + ' ' + this.user.lastName,
        modified: new Date().toISOString()
      })
      this.addLog({
        message: "Checking in CF Enterprise Task",
        level: "info"
      })
      if (task.ticketId) {
        try {
          await this.$http.post('/host-bill/add-ticket-tag', {
            ticketId: task.ticketId,
            grant_type: 'token',
            tag: `${this.user.firstName} ${this.user.lastName}`
          })
          await this.$http.post('/host-bill/update-ticket-status', {
            ticketNumber: task.ticketId,
            grant_type: 'token',
            status: 'In-Progress',
            fromMigration: true
          })
        } catch (e) {
          console.log(e.toString())
        }
      }
      try {
        const msg = `*${this.user.firstName}* *${this.user.lastName}* has checked into CF Enterprise task: ${task.domain}.`
        // await this.$http.post('utilities/send-slack-notification', {
        //   grant_type: 'token',
        //   msg,
        //   showButton: false,
        // });
      } catch (e) {
        console.log(e.toString());
      }
      const domain = task.domain;
      const data = {
        ticketId: task.ticketId || '',
        taskId: task.docId,
        type: 'info',
        actionType: 'CF Enterprise Task',
        message: `CF Enterprise for domain ${this.domainAdjustment(domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
        customer: {
          email: task.email,
          domain: domain,
        }
      }
      await this.addRecentActivity({...data});
      await this.addToAdminActiveTask({...data});
    },
    async checkOutTask(task) {
      this.addLog({
        message: "Checking out CF Enterprise Task",
        level: "info"
      })
      await db.collection('CFEnterpriseRequests').doc(task.docId).update({
        handledBy: '',
        modified: new Date().toISOString()
      })
      try {
        const msg = `*${this.user.firstName}* *${this.user.lastName}* has checked out from CF Enterprise Task: ${task.domain}.`
        // await this.$http.post('utilities/send-slack-notification', {
        //   grant_type: 'token',
        //   msg,
        //   showButton: false,
        // });
        const domain = task.domain;
        const data = {
          ticketId: task.ticketId || '',
          taskId: task.uid,
          type: 'info',
          actionType: 'CF Enterprise Task',
          message: `CF Enterprise Task for domain ${this.domainAdjustment(domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
          customer: {
            email: task.email,
            domain: domain,
          }
        }
        await this.addRecentActivity({...data})
        try {
          await this.removeAdminActiveTask({taskId: task.docId})
        } catch (e) {
          console.log(e.toString())
        }
      } catch (e) {
        console.log(e.toString());
      }
    },
    async finishTask(task, index) {
      this.$parent.$refs.ticketMessage.load(task, index, this.type)
    },
    openNotesModal(task) {
      this.$parent.$refs.notes.load(task)
    },
    async completeTask(m_index, t_index) {
      this.loader = 'complete' + m_index + t_index
      this.filteredTasks[m_index].checklist[t_index].pendingIsChecked = true
      this.filteredTasks[m_index].checklist[t_index].pendingCheckedBy = this.user.firstName + ' ' + this.user.lastName
      await this.updateChecklist(m_index)
      this.loader = null
    },
    async reviewTask(m_index, t_index) {
      this.loader = 'review' + m_index + t_index
      this.filteredTasks[m_index].checklist[t_index].reviewIsChecked = true
      this.filteredTasks[m_index].checklist[t_index].reviewCheckedBy = this.user.firstName + ' ' + this.user.lastName
      await this.updateChecklist(m_index)
      this.loader = null
    },
    openIDsModal(type, task) {
      this.$parent.$refs.idsModal.load(type, task)
    },
    openCommentModal(index, task) {
      if (!task.comments) {
        task.comments = []
      }
      let commentObject = {
        index,
        comments: task.comments || [],
        status: task.status
      }
      this.$refs.comment.load(commentObject)
    },
    async updateChecklistComments(object) {
      console.log('adding', object)
      await this.updateChecklist(object.index)
    },
    async updateChecklist(index, task) {
      console.log('check', this.filteredTasks[index])
      if (task && !task.answer) {
        return;
      }
      await db.collection('CFEnterpriseRequests').doc(this.filteredTasks[index].docId).update({
        checklist: this.filteredTasks[index].checklist,
        modified: new Date().toISOString()
      })
    },
    filteredTaskList(task) {
      const { status, checklist, requestedPlan } = task;
      if (status === 'pending' || !requestedPlan.includes('Mediavine')) {
        return checklist.filter(el => !el.reviewOnly);
      }
      return checklist
    },
  }
}
</script>

<style scoped>
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
.multiselect__tags-wrap{
  display: flex !important;
}
</style>
